import AddTemplate from "../_templates/AddTemplate";
import { competitionSchema } from "../../../schemas/competition.schema";
import { createCompetition } from "../../../api/competitions.api";

export default function AddCompetition() {
  return (
    <AddTemplate
      title="Add Competition"
      schema={competitionSchema}
      createFn={createCompetition}
      redirectPath="/cricket/competitions"
    />
  );
}
